/** Public support page copy for investxapp.com/support */
export const supportPageContent = {
  title: "InvestX Support",
  subtitle: "Need help with InvestX?",
  description:
    "We're here to help. If you have questions, encounter a problem, or would like to suggest a new feature, feel free to contact us.",
  contact: {
    title: "Contact",
    email: "support@investxapp.com",
    responseTime: "We usually respond within 24–48 hours.",
  },
  faq: {
    title: "Frequently Asked Questions",
    items: [
      {
        question: "How do I add a transaction?",
        answer:
          "Go to Invest → Add Transaction and choose the asset you want to add.",
      },
      {
        question: "Is my data secure?",
        answer:
          "Yes. Your portfolio data is securely stored using encrypted cloud services.",
      },
      {
        question: "Does InvestX execute trades?",
        answer:
          "No. InvestX is a portfolio tracker. We do not act as a broker or execute trades.",
      },
      {
        question: "Can I import my portfolio?",
        answer:
          "Yes. InvestX supports importing transactions from supported file formats and broker exports.",
      },
      {
        question: "Which assets are supported?",
        answer:
          "InvestX supports stocks, ETFs, cryptocurrencies, and many international exchanges.",
      },
    ],
  },
  featureRequests: {
    title: "Feature Requests",
    description:
      "We're actively developing InvestX and regularly release new features. We'd love to hear your ideas.",
  },
  bugReports: {
    title: "Report a Bug",
    description: "If something isn't working correctly, please include:",
    requirements: [
      "Device model",
      "Operating system version",
      "InvestX app version",
      "A short description of the issue",
      "Screenshots if possible",
    ],
  },
  development: {
    title: "Continuous Development",
    description:
      "InvestX is actively developed. We regularly release new features, improvements, and performance updates based on community feedback.",
  },
  footer: {
    links: [
      { title: "Privacy Policy", url: "/privacy" },
      { title: "Terms of Service", url: "/terms" },
    ],
  },
};
